<form [formGroup]="form" (submit)="save()" class="settings-general-wrapper">
  <div
    class="settings-card"
    [class.dropdown-open]="openDropdown === 'role' || openDropdown === 'state' || openDropdown === 'timezone'"
  >
    <wm-common-text class="section-title" [data]="{ text: 'General Settings' }"></wm-common-text>

    <div *ngIf="loadingClient" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="general-content" *ngIf="!loadingClient && client">
      <div class="general-form">

        <wm-common-textfield
            [data]="{ label: 'Name', placeholder: 'Name' }"
            formControlName="clientName"
            ngDefaultControl>
        </wm-common-textfield>

        <div class="wm-input-wrapper">
            <label class="wm-label">Admin Role</label>
            <div class="custom-dropdown-trigger"
                 [class.open]="openDropdown === 'role'"
                 (click)="toggleDropdown('role', $event)">

                <span class="selected-text" *ngIf="getRoleName(form.get('adminRole').value)">
                    {{ getRoleName(form.get('adminRole').value) }}
                </span>
                <span class="placeholder-text" *ngIf="!getRoleName(form.get('adminRole').value)">
                    Select Role
                </span>
            </div>

            <div class="dropdown-options" *ngIf="openDropdown === 'role'">
                <div class="dropdown-item"
                     *ngFor="let role of adminRoles"
                     [class.selected]="form.get('adminRole').value === role.id"
                     (click)="selectOption('adminRole', role.id)">
                    {{ role.name }}
                </div>
                <div class="dropdown-item" *ngIf="!adminRoles || adminRoles.length === 0" style="color:#999; cursor: default;">
                    No roles available
                </div>
            </div>
            <div class="error-text" *ngIf="adminRoles && adminRoles.length === 0">
                No roles with sufficient permissions found.
            </div>
        </div>

        <div class="wm-input-wrapper">
            <label class="wm-label">State</label>
            <div class="custom-dropdown-trigger"
                 [class.open]="openDropdown === 'state'"
                 (click)="toggleDropdown('state', $event)">

                <span class="selected-text" *ngIf="form.get('clientState').value">
                    {{ form.get('clientState').value }}
                </span>
                <span class="placeholder-text" *ngIf="!form.get('clientState').value">
                    Select State
                </span>
            </div>

            <div class="dropdown-options" *ngIf="openDropdown === 'state'">
                <div class="dropdown-item"
                     *ngFor="let state of states"
                     [class.selected]="form.get('clientState').value === state"
                     (click)="selectOption('clientState', state)">
                    {{ state }}
                </div>
            </div>
        </div>

        <div class="wm-input-wrapper">
            <label class="wm-label">Timezone</label>
            <div class="custom-dropdown-trigger"
                 [class.open]="openDropdown === 'timezone'"
                 (click)="toggleDropdown('timezone', $event)">

                <span class="selected-text" *ngIf="getTimezoneName(form.get('timeZone').value)">
                     {{ getTimezoneName(form.get('timeZone').value) }}
                </span>
                <span class="placeholder-text" *ngIf="!getTimezoneName(form.get('timeZone').value)">
                    Select Timezone
                </span>
            </div>

            <div class="dropdown-options" *ngIf="openDropdown === 'timezone'">
                <div class="dropdown-item"
                     *ngFor="let tz of timeZones"
                     [class.selected]="form.get('timeZone').value === tz.Id"
                     (click)="selectOption('timeZone', tz.Id)">
                    {{ tz.DisplayName }}
                </div>
            </div>
        </div>

        <div class="toggle-row">
          <input type="checkbox" class="native-toggle" formControlName="visibleToPublic" />
          <wm-common-text [data]="{ text: 'Visible to public?' }"></wm-common-text>
        </div>
      </div>

      <div class="upload-section">
        <div class="upload-card">
          <wm-common-text class="header-logo-title" [data]="{ text: 'Upload Large Logo' }"></wm-common-text>
          <div class="upload-dropzone" (click)="largeLogoInput.click()"   (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event, 'logo')"
         *ngIf="!client.logoURL">
            <div class="upload-icon"><mat-icon>upload_file</mat-icon></div>
            <div class="upload-text">
              <wm-common-text class="browse-text-info" [data]="{ text: 'Drag and drop files' }"></wm-common-text>
              <wm-common-text class="browse-text" [data]="{ text: 'here or browse' }"></wm-common-text>
            </div>
            <input #largeLogoInput type="file" hidden accept=".png,.jpg,.jpeg" (change)="onFileSelected($event, 'logo')" />
          </div>
          <div class="upload-dropzone"   *ngIf="client.logoURL" style="border-style: solid; padding: 10px;">
             <img [src]="client.logoURL" class="img-fluid" style="max-height: 150px; max-width: 100%;" />
          </div>
          <wm-common-text class="hint" [data]="{ text: 'Recommended height: 150px' }"></wm-common-text>
          <div class="action-buttons">
            <button type="button" class="cancel-btn" (click)="requestDeleteLogo('logo')" *ngIf="client.logoURL">DELETE</button>
            <button type="button" class="cancel-btn" *ngIf="!client.logoURL">CLOSE</button>
            <button type="button" class="submit-btn" (click)="onUploadButtonClick()" *ngIf="!client.logoURL">UPLOAD</button>
          </div>
        </div>

        <div class="upload-card">
          <wm-common-text class="header-logo-title" [data]="{ text: 'Upload Header Logo' }"></wm-common-text>
          <div class="upload-dropzone" (click)="headerLogoInput.click()" *ngIf="!client.headerLogoURL"  (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event, 'header')">
            <div class="upload-icon"><mat-icon>upload_file</mat-icon></div>
            <div class="upload-text">
              <wm-common-text class="browse-text-info" [data]="{ text: 'Drag and drop files' }"></wm-common-text>
              <wm-common-text class="browse-text" [data]="{ text: 'here or browse' }"></wm-common-text>
            </div>
            <input #headerLogoInput type="file" hidden accept=".png,.jpg,.jpeg" (change)="onFileSelected($event, 'header')" />
          </div>
          <div class="upload-dropzone" *ngIf="client.headerLogoURL" style="border-style: solid; padding: 10px;">
             <img [src]="client.headerLogoURL" class="img-fluid" style="max-height: 50px; max-width: 100%;" />
          </div>
          <wm-common-text class="hint" [data]="{ text: 'Recommended height: 27px' }"></wm-common-text>
          <div class="action-buttons">
            <button type="button" class="cancel-btn" (click)="requestDeleteLogo('header')" *ngIf="client.headerLogoURL">DELETE</button>
            <button type="button" class="cancel-btn" *ngIf="!client.headerLogoURL">CLOSE</button>
            <button type="button" class="submit-btn" (click)="onUploadButtonClick()" *ngIf="!client.headerLogoURL">UPLOAD</button>
          </div>
        </div>
      </div>
    </div>

    <div class="save-row">
      <button type="submit" class="btn-disabled" [class.btn-primary]="!form.invalid" [class.btn-disabled]="form.invalid || saving" [disabled]="form.invalid || saving">
        <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        <span *ngIf="!saving">SAVE</span>
        <span *ngIf="saving">SAVING...</span>
      </button>
    </div>
  </div>

  <div
    class="settings-card"
    *ngIf="!isNewClient && client"
    [class.dropdown-open]="openDropdown === 'mode'"
  >
    <wm-common-text class="section-title" [data]="{ text: 'Jurisdiction Mode', fontWeight: 600 }"></wm-common-text>
    <wm-common-text
      class="description"
      [data]="{ text: 'Test mode suppresses jurisdiction-scoped outbound email. Live mode sends email normally.' }"
    ></wm-common-text>

    <div class="wm-input-wrapper">
      <label class="wm-label">Mode</label>
      <div
        class="custom-dropdown-trigger"
        data-testid="jurisdiction-mode"
        [class.open]="openDropdown === 'mode'"
        [class.disabled]="!canEditFeatureConfiguration"
        (click)="canEditFeatureConfiguration && toggleDropdown('mode', $event)"
      >
        <span class="selected-text">{{ getModeName(form.get('mode').value) }}</span>
      </div>

      <div class="dropdown-options" *ngIf="openDropdown === 'mode'">
        <div
          class="dropdown-item"
          [class.selected]="form.get('mode').value === 0"
          (click)="selectOption('mode', 0)"
        >
          Test
        </div>
        <div
          class="dropdown-item"
          [class.selected]="form.get('mode').value === 1"
          (click)="selectOption('mode', 1)"
        >
          Live
        </div>
      </div>
    </div>

    <wm-common-text
      class="hint"
      *ngIf="!canEditFeatureConfiguration"
      [data]="{ text: 'Mode changes are restricted to Global Administrators.' }"
    ></wm-common-text>
  </div>

  <div class="settings-card new-layout" *ngIf="!isNewClient && canEditFeatureConfiguration">
    <wm-common-text class="section-title" [data]="{ text: 'Feature Configuration', fontWeight: 600 }"></wm-common-text>
    <div class="warning-row">
      <mat-icon class="warning-icon">warning</mat-icon>
      <wm-common-text class="warning-text" [data]="{ text: 'Warning: this action will change the experience for the end user', color: 'warning' }"></wm-common-text>
    </div>
    <wm-common-text class="description" [data]="{ text: '&quot;Use New Layout&quot; controls whether applicants are redirected to the new applicant home page or the old client landing page' }"></wm-common-text>
    <div class="toggle-row-warning">
      <!-- Start Code added by Sanchit on 04/27/2026 -->
      <!-- <input type="checkbox" class="native-toggle" formControlName="useNewLayout" /> -->
       <input
          type="checkbox"
          class="native-toggle"
          [checked]="form.get('useNewLayout')?.value"
          (click)="$event.preventDefault(); onToggleIntent()"
        />
        <!-- End Code added by Sanchit on 04/27/2026 -->
      <wm-common-text [data]="{ text: 'Use New Layout' }"></wm-common-text>
    </div>
  </div>
</form>

<wm-common-confirmation-modal
  [data]="confirmData"
    data-testid="jurisdiction-mode-confirmation"
  (onYesClick)="onConfirmModalYes()"
  (onNoClick)="onConfirmModalNo()"
  [isApplicantMobileview]="true"
></wm-common-confirmation-modal>
